import { Routes } from "@angular/router";
import { AuthGuard } from "./shared/authguards/auth.guard";
import { epakRoleGuard } from "./shared/authguards/epak-role.guard";
import { ExternalPatientRoleGuard } from "./shared/authguards/external-patient-role.guard";

export const IMPORTANT_INFO_ROUTES: Routes = [
  {
    path: "diseases/info",
    loadComponent: () => import("./features/diseases/disease-important-info/disease-important-info.component").then(m => m.DiseaseImportantInfoComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.diseaseInfo" },
  },
  {
    path: "prescriptions/info",
    loadComponent: () => import("./features/prescriptions/prescription-important-info/prescription-important-info.component").then(m => m.PrescriptionImportantInfoComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.prescriptionInfo" },
  },
  {
    path: "terminate-leave/info",
    loadComponent: () => import("./features/terminate-leave/terminate-important-info/terminate-important-info.component").then(m => m.TerminateImportantInfoComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.terminateLeaveInfo" },
  },
  {
    path: "certificates/info",
    loadComponent: () => import("./features/certificates/certificates-important-info/certificates-important-info.component").then(m => m.CertificatesImportantInfoComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.certificatesInfo" },
  },
  {
    path: "appointment/info",
    loadComponent: () => import("./features/appointment/appointment-important-info/appointment-important-info.component").then(m => m.AppointmentImportantInfoComponent),
    canActivate: [AuthGuard, epakRoleGuard],
    data: { title: "pageTitles.appointmentInfo" },
  },
  {
    path: "question/info",
    loadComponent: () => import("./features/question/question-important-info/question-important-info.component").then(m => m.QuestionImportantInfoComponent),
    canActivate: [AuthGuard, epakRoleGuard, ExternalPatientRoleGuard],
    data: { title: "pageTitles.questionInfo" },
  },
  {
    path: "cross-communication/info",
    loadComponent: () => import("./features/outside-institution-message/cross-communication-important-info/cross-communication-important-info.component").then(m => m.CrossCommunicationImportantInfoComponent),
    canActivate: [AuthGuard, ExternalPatientRoleGuard, epakRoleGuard],
    data: { title: "pageTitles.info" },
  },
];
